export default "<p>KONTO {{konto.name}}</p>\n"